import { createAction, props } from '@ngrx/store';

import { NewsItem } from '@app-modules/news/types';

import { NEWS_LIST_ACTIONS } from '../news-list-actions.type';

export const loadNewsAction = createAction(NEWS_LIST_ACTIONS.LOAD_NEWS);
export const loadNewsSuccessAction = createAction(
  NEWS_LIST_ACTIONS.LOAD_NEWS_SUCCESS,
  props<{
    newsList: NewsItem[];
  }>(),
);
